import axios from 'axios'
import Element from 'element-ui'
import router from './router'
import store from './store'

// axios.defaults.baseURL = "http://192.168.15.104:12386"
// axios.defaults.baseURL = "http://192.168.0.44:12386"
axios.defaults.baseURL = "http://qms.borui-group.com:12386/"

// 前置拦截
axios.interceptors.request.use(config => {
    if(localStorage.getItem("token") != null && localStorage.getItem("token") != ""){
        config.headers['Authorization'] = localStorage.getItem("token");
    }
    return config
})

axios.interceptors.response.use(response => {
    let res = response.data;

    if (res.code === 200) {
      return response
    } else {

      Element.Message.error(response.data.msg, {duration: 1000})

      return Promise.reject(response.data.msg)
    }
  },
  error => {
    if(error.response.status === 500){
        error.message = error.response.data.message
        if(error.message.indexOf("请重新登录")>=0){
            router.push('/login');
        }
    }else if(error.response.data) {
      error.message = error.response.data.msg
    }

    if(error.response.status === 401) {
      store.commit("REMOVE_INFO")
      router.push("/login")
    }

    Element.Message.error(error.message, {duration: 1000})
    return Promise.reject(error)
  }
)